import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl'

class TitleContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function(){},
            title: content.title || ''
        }
        this.handleFormChange = this.handleFormChange.bind(this)
    }

    componentDidMount() {
        this.state.onChange({
            title: this.state.title,
        })
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            title: content.title || ''
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, () => {
            this.state.onChange({
                title: this.state.title,
            })
        })
    }

    render() {
        const messages = defineMessages({
            "title_placeholder": {
                id: 'templates.sections.form.edit.content.title.title_placeholder',
                defaultMessage: 'Title',
            },
        })
        return (
            <div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="title">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.title.label"
                            defaultMessage="Title"
                        />
                    </label>
                    <div className="col-10">
                        <input
                            name="title"
                            value={this.state.title}
                            onChange={this.handleFormChange}
                            id="title"
                            type="text"
                            className="form-control"
                            placeholder={this.props.intl.formatMessage(messages['title_placeholder'])}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.title.title_description"
                                defaultMessage="Title that will be seen on the quote"
                            />
                        </small>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(TitleContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/title/input.component.jsx